import { Link } from 'react-router-dom';
import { Phone, Envelope, MapPin, Globe } from '@phosphor-icons/react';
import { useTheme } from '../contexts/ThemeContext';
import { useSiteConfig } from '../contexts/SiteConfigContext';

export default function Footer() {
    const { theme } = useTheme();
    const { config } = useSiteConfig();
    
    const LOGO_GLOBAL = config.logo_global;
    const LOGO_LUXURY = config.logo_luxury;

    return (
        <footer 
            data-testid="main-footer"
            className={`${theme === 'dark' ? 'bg-mmd-surface-dark border-white/10' : 'bg-mmd-light-bg border-black/10'} border-t`}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
                    {/* Brand Section */}
                    <div className="lg:col-span-2">
                        <div className="flex items-center gap-4 mb-6">
                            <img src={LOGO_GLOBAL} alt="MMD Global" className="h-16 w-16 rounded-full object-cover" />
                            <img src={LOGO_LUXURY} alt="MMD Luxury Cars" className="h-16 w-16 rounded-full object-cover" />
                        </div>
                        <p className={`text-sm leading-relaxed ${theme === 'dark' ? 'text-mmd-silver/80' : 'text-mmd-navy/70'}`}>
                            MMD Global Enterprise - Votre partenaire de confiance pour le matériel de bureau professionnel 
                            et l'importation de véhicules de luxe. Connecting quality to the world.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="font-heading font-semibold text-lg mb-4">Navigation</h4>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/" className="text-sm hover:text-mmd-gold transition-colors" data-testid="footer-link-home">
                                    Accueil
                                </Link>
                            </li>
                            <li>
                                <Link to="/materiel" className="text-sm hover:text-mmd-gold transition-colors" data-testid="footer-link-materiel">
                                    Matériel de bureau
                                </Link>
                            </li>
                            <li>
                                <Link to="/voitures" className="text-sm hover:text-mmd-gold transition-colors" data-testid="footer-link-voitures">
                                    Voitures
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact" className="text-sm hover:text-mmd-gold transition-colors" data-testid="footer-link-contact">
                                    Contact
                                </Link>
                            </li>
                            <li>
                                <Link to="/a-propos" className="text-sm hover:text-mmd-gold transition-colors" data-testid="footer-link-about">
                                    À propos
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h4 className="font-heading font-semibold text-lg mb-4">Contact</h4>
                        <ul className="space-y-3">
                            <li className="flex items-center gap-3 text-sm">
                                <Phone size={18} className="text-mmd-gold" />
                                <a href="tel:+221768462040" className="hover:text-mmd-gold transition-colors">
                                    +221 76 846 20 40
                                </a>
                            </li>
                            <li className="flex items-center gap-3 text-sm">
                                <Envelope size={18} className="text-mmd-gold" />
                                <a href="mailto:contact@mmd-global.com" className="hover:text-mmd-gold transition-colors">
                                    contact@mmd-global.com
                                </a>
                            </li>
                            <li className="flex items-center gap-3 text-sm">
                                <MapPin size={18} className="text-mmd-gold" />
                                <span>Dakar, Sénégal</span>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className={`mt-12 pt-8 border-t ${theme === 'dark' ? 'border-white/10' : 'border-black/10'} flex flex-col sm:flex-row justify-between items-center gap-4`}>
                    <p className={`text-sm ${theme === 'dark' ? 'text-mmd-silver/60' : 'text-mmd-navy/60'}`}>
                        © {new Date().getFullYear()} MMD Global Enterprise. Tous droits réservés.
                    </p>
                    <div className="flex items-center gap-2 text-sm">
                        <Globe size={16} className="text-mmd-gold" />
                        <a 
                            href="https://www.dkr-consulting.com" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="hover:text-mmd-gold transition-colors"
                            data-testid="footer-developer-link"
                        >
                            DKR Consulting
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
